import React from "react";
import LanguageSelect from "./language/LanguageSelect";
import { useTranslation } from "react-i18next";
import classes from "./TopMessage.module.scss";
import classNames from "classnames/bind";

type TopMenuProps = {
  showLangSelect: boolean;
};

const TopMessage = ({ showLangSelect }: TopMenuProps) => {
  const { t } = useTranslation();
  const cx = classNames.bind(classes);

  return showLangSelect ? (
    <div
      className={cx(classes.topMessage, classes.topMessageCenterSpaceAround)}
    >
      <span className={cx(classes.topMessageLeft)}></span>
      <span className={cx(classes.topMessageCenter)}>
        <i
          className={`pi pi-exclamation-circle ${cx(classes.topMessageIcon)}`}
        />
        {t("homepage_disclaimer")}
      </span>
      <span className={cx(classes.topMessageRight)}>
        <LanguageSelect />
      </span>
    </div>
  ) : (
    <div className={cx(classes.topMessage)}>
      <i className={`pi pi-exclamation-circle ${cx(classes.topMessageIcon)}`} />
      {t("homepage_disclaimer")}
    </div>
  );
};

export default TopMessage;
